/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../routing/state-utils';
import {PERMISSIONS} from "../../components/auth/auth-constants";



export function adminStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
states.add('app.adm', {
          abstract: true,
          data: {
            app: ['ADVERTISING', 'DATA', 'POLITICAL']
          },
          resolve: {
            readOnly: function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasNetwork(PERMISSIONS.manageSystem.apiKey)
                && !LocalUserPermissions.hasDataNetworkPermission(PERMISSIONS.dataAdmin.apiKey)
                && !LocalUserPermissions.hasNetworkPermission('POLITICAL_ADMIN', null, 'POLITICAL');
            }
          },
          url: '/admin'
        });
  return states.build();
}